import React from "react"
import Layout from "../components/layout.en"
import SEO from "../components/seo"
import SmallHeader from "../components/SmallHeader"
import { Col, Container, Row } from "reactstrap"
import TitleBlock from "../components/blocks/TitleBlock"
import ContactInfo from "../components/general/ContactInfo"
import { graphql, useStaticQuery } from "gatsby"

const Cennik = () => {
  const images = useStaticQuery(graphql`
    {
      cover: file(
        name: { eq: "general-page-background" }
        relativeDirectory: { eq: "headers" }
      ) {
        id
        childImageSharp {
          fluid(quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO title="Price list for the 2025 season" />
      <SmallHeader title="Price list" backgroundName={images.cover} />

      <Container>
        <Row>
          <Col xs="12" md="12" className="mr-auto ml-auto">
            <div className="text-center section">
              <TitleBlock
                title="Price list for the 2025 season"
                headingLevel="h3"
                extendedClasses="color-sea font-weight-bold"
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs="12" md="8" className="mr-auto ml-auto">
            <div className={`table-responsive`}>
              <table className={`table price-table`}>
                <thead>
                  <tr>
                    <th></th>
                    <th>06.06 - 30.06 and 01.09 - 14.09</th>
                    <th>01.07 - 31.08</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Two-person apartment</td>
                    <td className={`text-center`}>250PLN/night</td>
                    <td className={`text-center`}>300PLN/night</td>
                  </tr>

                  <tr>
                    <td>Three-person apartment</td>
                    <td className={`text-center`}>280PLN/night</td>
                    <td className={`text-center`}>350PLN/night</td>
                  </tr>

                  <tr>
                    <td>Three-person apartment (one bedroom apartment)</td>
                    <td className={`text-center`}>320PLN/night</td>
                    <td className={`text-center`}>380PLN/night</td>
                  </tr>

                  <tr>
                    <td>Four-person apartment (one bedroom apartment)</td>
                    <td className={`text-center`}>380PLN/night</td>
                    <td className={`text-center`}>450PLN/night</td>
                  </tr>

                  <tr>
                    <td>Five-person apartment (one bedroom apartment)</td>
                    <td className={`text-center`}>410PLN/night</td>
                    <td className={`text-center`}>480PLN/night</td>
                  </tr>

                  <tr>
                    <td>
                      Private garage parking space (advance booking necessary)
                    </td>
                    <td className={`text-center`}>10PLN/night</td>
                    <td className={`text-center`}>20PLN/night</td>
                  </tr>

                  <tr>
                    <td>Private parking space (advance booking necessary)</td>
                    <td className={`text-center`}>free of charge</td>
                    <td className={`text-center`}>10PLN/night</td>
                  </tr>
                  <tr>
                    <td>Kids under 3</td>
                    <td colSpan={`2`} className={`text-center`}>
                      free of charge
                    </td>
                  </tr>
                  <tr>
                    <td>Extra bed for children over 4 years and adults</td>
                    <td colSpan={`2`} className={`text-center`}>
                      50PLN/night
                    </td>
                  </tr>
                  <tr>
                    <td>Baby’s bed with linen (advance booking necessary)</td>
                    <td colSpan={`2`} className={`text-center`}>
                      50 PLN (single charge)
                    </td>
                  </tr>
                  <tr>
                    <td>
                      High chair, baby bathtub (advance booking necessary)
                    </td>
                    <td colSpan={`2`} className={`text-center`}>
                      free of charge
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <Row>
              <Col md="12">
                <p className="pt-5">
                  <span className="color-sea font-weight-bold">Check-in:</span>{" "}
                  starts from 16:00 on the first day of stay and ends at 10:00
                  on the last day of stay.
                </p>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <p className="pt-5 font-weight-bold">
                  Pets are not allowed in the hotel.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col xs="12" md="12" className="ml-auto mr-auto">
            <div className="section">
              <ContactInfo />
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Cennik
